import http from '../../utils/fetch';
export default {
    selectPage(query){
        return http({
            url: '/api/swyl/v1/demo/leaveOffice/selectPage',
            method: 'post',
            params: query
        });
    },
    insert(query){
        return http({
            url: '/api/swyl/v1/demo/leaveOffice/insert',
            method: 'post',
            params: query
        });
    },
    selectTask(){
        return http({
            url: '/api/swyl/v1/demo/leaveOffice/selectTask',
            method: 'post'
        });
    },
    selectSPData(query) {
        return http({
            url: '/api/swyl/v1/demo/leaveOffice/selectSPData',
            method: 'post',
            params: query
        });
    },
    auditLeave(query) {
        return http({
            url: '/api/swyl/v1/demo/leaveOffice/auditLeave',
            method: 'post',
            params: query
        });
    }
}